import { gql, useApolloClient } from "@apollo/client"
import {
  useGenerateTripMutationMutation,
  useScheduleListSummaryQuery,
} from "generated/graphql"
import { TRIPS_FOR_DATE } from "graphql/inward/inwarding.queries.gql"
import {
  ASSIGNED_TRIPS_LIST,
  ASSIGNED_TRIPS_MAP,
} from "graphql/trip/trip.queries.gql"
import { get, omit } from "lodash-es"
import {
  useAssignedTripsListVariables,
  useAssignedTripsMapVariables,
} from "pages/vehicle/assigned/useAssignedTrips"
import { useDispatch } from "react-redux"
import {
  CLEAR_SELECTED_SCHEDULES,
  useSchedulingVariables,
} from "store/scheduling.redux"
import AppToaster from "utils/AppToaster"
import { SCHEDULE_LIST_SUMMARY } from "./scheduling.queries.gql"
export function useScheduleListSummary() {
  const defaultVariables = useSchedulingVariables()

  const { data } = useScheduleListSummaryQuery({
    variables: omit(defaultVariables, ["first", "skip"]),
    notifyOnNetworkStatusChange: true,
  })
  return data?.schedulesForDateSummary
}

export function useGenerateTrips(onCompleted?: any) {
  const dispatch = useDispatch()
  const client = useApolloClient()

  const listVariables = useAssignedTripsListVariables()
  const mapVariables = useAssignedTripsMapVariables()
  const scheduleVariables = useSchedulingVariables()

  return useGenerateTripMutationMutation({
    refetchQueries: [
      {
        query: TRIPS_FOR_DATE,
        variables: {
          date: scheduleVariables?.date,
          first: 11,
          skip: 0,
        },
      },
      // Refetch all respective queries for both the VehicleTracking MAP and TABLE
      {
        query: ASSIGNED_TRIPS_LIST,
        variables: listVariables,
      },
      {
        query: ASSIGNED_TRIPS_MAP,
        variables: mapVariables,
      },
      {
        query: SCHEDULE_LIST_SUMMARY,
        variables: omit(scheduleVariables, ["first", "skip"]),
      },
    ],
    onCompleted({ generateTrip }) {
      AppToaster.show({
        icon: "endorsed",
        intent: "success",
        message: `${
          generateTrip?.trips?.length ?? 0
        } Trips generated successfully!`,
      })

      dispatch({
        type: CLEAR_SELECTED_SCHEDULES,
      })
      onCompleted?.()
    },
    update(_, data) {
      const trips = get(data, "data.generateTrip.trips", [])
      // Make all the schedules notified
      trips.forEach(t =>
        t.bookings.forEach(b => {
          client.writeFragment({
            fragment: gql`
              fragment SheduleNotifiedFrag on ScheduleType {
                isNotified
              }
            `,
            id: `ScheduleType:${b.schedule && b.schedule.id}`,
            data: {
              __typename: "ScheduleType",
              isNotified: true,
            },
          })
        })
      )
    },
    onError({ message }) {
      AppToaster.show({ message, intent: "danger" })
    },
  })
}
